<vc-dialog
    [visible]="visible"
    title="{{ forceReset ? resetPasswordText : changePasswordText }}"
    [secondaryLabel]="'COMMON_UI.CANCEL' | transloco"
    [loading]="loading"
    [width]="'430px'"
    [showCloseIcon]="!forceReset"
    [showSecondary]="!forceReset"
    [closeOnPrimary]="false"
    [clearFormOnClose]="true"
    (primaryTrigger)="onChangePassword(changePasswordForm.valid)"
    (visibleChange)="visibleChange.emit($event)">
    <span id="vc-reset-form-description" style="display: none">
        {{ forceReset ? resetPasswordText : changePasswordText }} form
    </span>
    <vc-form
        #changePasswordForm
        [ariaDescribedBy]="'vc-reset-form-description'"
        [showButtons]="false"
        [showPrimaryButton]="false"
        [showSecondaryButton]="false">
        @if (!!username) {
            <input
                class="sr-only"
                type="text"
                autocomplete="username"
                aria-required="true"
                aria-invalid="false"
                [defaultValue]="username" />
        }
        <vc-password
            class="space-bottom-16"
            style="top: 2px; position: relative"
            [label]="'ACCOUNT.CURRENT_PASSWORD' | transloco"
            [requiredText]="'COMMON_UI.VALIDATION.FIELD_IS_REQUIRED' | transloco"
            [required]="true"
            [autocomplete]="'current-password'"
            [(value)]="currentPassword"
            (valueChange)="onPasswordInput()"
            [showClear]="true"></vc-password>
        <vc-password
            class="space-bottom-16"
            [label]="'LOGIN.NEW_PASSWORD' | transloco"
            [description]="'LOGIN.PASSWORD_REQUIREMENTS_TEXT' | transloco"
            [required]="true"
            [requiredText]="'COMMON_UI.VALIDATION.FIELD_IS_REQUIRED' | transloco"
            [maxLength]="32"
            [requiredMaxCharsText]="'COMMON_UI.PASSWORD.REQUIRED_MAX_CHARACTERS' | transloco"
            [minLength]="8"
            [requiredMinCharsText]="'COMMON_UI.PASSWORD.REQUIRED_MIN_CHARACTERS' | transloco"
            [minNumbers]="1"
            [minNumberCharErrorMsg]="'COMMON_UI.PASSWORD.NUMBER_REQUIRED' | transloco"
            [minUpper]="1"
            [minUppercaseCharErrorMsg]="'COMMON_UI.PASSWORD.UPPERCASE_REQUIRED' | transloco"
            [minSpecial]="1"
            [minSpecialCharErrorMsg]="'COMMON_UI.PASSWORD.SPECIAL_REQUIRED' | transloco"
            [mustNotMatch]="currentPassword"
            [matchErrorMsg]="'COMMON_UI.PASSWORD.DOES_MATCH_CURRENT' | transloco"
            [showVisibleButton]="true"
            [autocomplete]="'new-password'"
            [(value)]="newPassword"
            (valueChange)="onPasswordInput()"
            [showClear]="true"></vc-password>
        <vc-password
            [label]="'LOGIN.REPEAT_PASSWORD' | transloco"
            [requiredText]="'COMMON_UI.VALIDATION.FIELD_IS_REQUIRED' | transloco"
            [verifyErrorMsg]="'COMMON_UI.PASSWORD.DOES_NOT_MATCH' | transloco"
            [required]="true"
            [showVisibleButton]="true"
            [mustMatch]="newPassword"
            [autocomplete]="'new-password'"
            [(value)]="confirmPassword"
            (valueChange)="onPasswordInput()"
            [showClear]="true"></vc-password>
    </vc-form>
</vc-dialog>
